import _extends from 'babel-runtime/helpers/extends';
import { jsonResponse } from 'fetch-utilities';

var PENDING = 'store/brands/PENDING';
var LOADING = 'store/brands/LOADING';
var LOADED = 'store/brands/LOADED';

var initialState = {
  state: PENDING,
  data: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOADING:
      return _extends({}, state, {
        state: 'LOADING'
      });
    case LOADED:
      return _extends({}, state, {
        state: action.error ? 'ERROR' : 'LOADED',
        data: action.error ? null : action.payload,
        error: action.error ? action.payload : null
      });

    default:
      return state;
  }
}

var load = function load() {
  return function (dispatch, _getState, client) {
    dispatch({
      type: LOADING
    });

    dispatch({
      type: LOADED,
      payload: client('/brands').then(jsonResponse)
    });
  };
};

export { PENDING, LOADING, LOADED, load };
export default reducer;
